import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["container", "id", "name", "placeholder", "label", "icon", "to", "command", "url", "items", "disabled", "visible", "target", "separator"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.MenuItemTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.MenuItemTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.MenuItemTypeConst.CLASS) ?? '']: true }),
        name: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.NAME),
        placeholder: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.PLACEHOLDER),
        label: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.LABEL),
        icon: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.ICON),
        to: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.TO),
        command: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.COMMAND),
        url: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.URL),
        items: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.ITEMS),
        disabled: _ctx.getPropertyBooleanValue(_ctx.MenuItemTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.MenuItemTypeConst.VISIBLE),
        target: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.TARGET),
        separator: _ctx.getPropertyBooleanValue(_ctx.MenuItemTypeConst.SEPARATOR),
        key: _ctx.getPropertyValue(_ctx.MenuItemTypeConst.KEY),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicktest && _ctx.clicktest(...args)))
      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.MenuItemTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}